export const formFields = [
  { label: 'Application', key: 'applicationName', isRequired: true },
  {
    label: 'Recovery SLA',
    key: 'recoverySLA',
    type: 'time',
    decoratorWord: 'hours',
  },
  { label: 'Hosting Location', key: 'hostingLocation' },
  {
    label: 'DR Plan in Place',
    key: 'drPlanInPlace',
    type: 'select',
    options: [
      { label: 'Yes', value: 'true' },
      { label: 'No', value: 'false' },
    ],
  },
  {
    label: 'Plan Owner First Name',
    key: 'planOwnerfirstName',
  },
  {
    label: 'Plan Owner Last Name',
    key: 'planOwnerlastName',
  },
  { label: 'Email', key: 'email', type: 'email' },
  { label: 'Phone', key: 'phone', type: 'text' },
];
